import { render, staticRenderFns } from "./IconQuestionRounded.vue?vue&type=template&id=54d4167e&scoped=true"
import script from "./IconQuestionRounded.vue?vue&type=script&lang=js"
export * from "./IconQuestionRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4167e",
  null
  
)

export default component.exports